// IMPORTANT - This should stay in sync with the quivalent actions in Sundae

import { SET_SHARED_VOUCHER_CODE } from '../actionTypes.constants'

export const setVoucherCode = (voucherCode) => ({
  type: SET_SHARED_VOUCHER_CODE,
  voucherCode,
})

export default undefined
